export default __webpack_public_path__ + "media/images/delete-c903b362.svg";